"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REMOVE_FROM_WISH_HOMECARE_LIST = exports.GET_WISH_LIST_HOMECARE_SKU_IDS = exports.GET_WISH_HOMECARE_LIST = exports.ADD_TO_WISH_HOMECARE_LIST = void 0;
const ADD_TO_WISH_HOMECARE_LIST = exports.ADD_TO_WISH_HOMECARE_LIST = 'addToWishHomecareList';
const GET_WISH_HOMECARE_LIST = exports.GET_WISH_HOMECARE_LIST = 'getWishHomecareList';
const REMOVE_FROM_WISH_HOMECARE_LIST = exports.REMOVE_FROM_WISH_HOMECARE_LIST = 'removeFromWishHomecareList';
const GET_WISH_LIST_HOMECARE_SKU_IDS = exports.GET_WISH_LIST_HOMECARE_SKU_IDS = 'getWishListHomecareSkuIDs';